<template>
  <div class="full">
    <div class="content-box" ref="bordercolor" :class="{ [currentLevel]: true, isRed: isRed }">
      <div class="question-row">
        <img v-if="currentLevel == 'easy'" src="../../icons/question-easy.svg" alt="Question">
        <img v-if="currentLevel == 'medium'" src="../../icons/question-medium.svg" alt="Question">
        <img v-if="currentLevel == 'hard'" src="../../icons/question-hard.svg" alt="Question">
      </div>
      <!-- <PhoneBox> -->
        <div class="marginer">
          <!-- <h1>Level: {{ currentLevel }}</h1> -->
          <ContentDisplay @answered="onAnswered" class="full" v-if="question" mode="mark" :question="question" @saveTo="(v) => { saveTo = v }" @view="(v) => { view = v }" @submit="onSubmit"></ContentDisplay>
        </div>
      <!-- </PhoneBox> -->

      <div class="question-row">
        <button class="close-btn" v-if="showClose" @click="$emit('close')">
          Incorrect, Close
        </button>
      </div>
    </div>
    <div v-if="view === 'myscript'" class="overlay">
      <MyScript @done="(v) => { myScriptDone({ value: v.latex }) }" @view="(v) => { view = v; }" />
    </div>
  </div>
</template>

<script>
import * as QS from '../compos/question.js'
import * as Question from '@/api/question.js'
import { setTimeout } from 'timers';


export default {
  components: {
    ContentDisplay: require('../compos/ContentDisplay.vue').default,
    MyScript: require('../compos/MyScript.vue').default,
    // PhoneBox: require('../compos/PhoneBox.vue').default,
  },
  data () {
    return {
      showClose: false,
      view: 'main',
      saveTo: false,
      QS,
      question: false,
      mark: false,
      fullObject: false
    }
  },
  props: {
    isRed: {
      default: false
    },
    currentLevel: {},
    questionID: {
      required: true
    }
  },
  mounted () {
    this.onLoad()
    // require('../compos/MyScript.vue').default.preload()
  },
  computed: {
    // questionID () {
    //   return this.$route.params.questionID
    // }
  },
  watch: {
    // question: {
    //   deep: true,
    //   handler (v) {
    //     // setTimeout(() => {
    //     if (v.result) {
    //       if (v.result.mark > 0) {
    //         this.$emit('right')
    //       } else {
    //         this.$emit('wrong')
    //       }
    //       console.log(v.result.mark)
    //       this.$forceUpdate()
    //       this.$parent.$forceUpdate()
    //     }
    //     // }, 1000)
    //   }
    // }
  },
  methods: {
    myScriptDone ({ value }) {
      if (!this.saveTo) { return }

      if (this.saveTo.operation === 'set') {
        this.saveTo.obj[this.saveTo.key] = `$$${(value + '').trim()}$$`
      } else {
        this.saveTo.obj[this.saveTo.key] += `$$${value}$$\n`
      }
    },
    async loadQuestion () {
      let resp = await Question.getQuestionOnly({ _id: this.questionID })
      this.fullObject = resp.data
      resp.data.document.ansData = false
      this.question = resp.data.document
      this.$forceUpdate()
      // this.question = QS.makeSampleQuestion()
    },
    onLoad () {
      this.loadQuestion()
      // setTimeout(() => {
      //   this.question = JSON.parse(JSON.stringify(require('../sample/math.json')))
      //   this.question.ansData = false
      //   this.$forceUpdate()
      // }, 500)
    },
    onAnswered (v) {
      this.showClose = true
      if (v) {
        if (v.mark > 0) {
          this.$emit('right', v)
        } else {
          this.$emit('wrong', v)
        }
        // console.log(v.mark)
        this.$forceUpdate()
        this.$parent.$forceUpdate()
      }
    },
    async onSubmit(val) {
      let resp = await Question.getQuestion({ _id: this.questionID })
      this.fullObject = resp.data

      setTimeout(() => {
        this.question.ansData = resp.data.document.ansData
        this.$forceUpdate()
      }, 230)
    }
  }
}
</script>

<style scoped>
.full{
  height: 100%;
}
.question-row{
  display: flex;
  justify-content: center;
  margin: 20px 0px;
}
.content-box{
  height: calc(100%);
  /* display: flex;
  justify-content: center;
  align-items: center; */
  max-width: 600px;
  margin: 0px auto;
  padding: 0px 15px;
  background-color: rgba(255, 255, 255, 0.938);
  overflow: auto;
  max-height: 100vh;

  border: #1B1464 solid 5px;
  border-radius: 30px;
  box-shadow: 0px 0px 30px 0px #f9f9f9;
  color: black;
  transform: translateY(30px);
}


.content-box.easy{
  border-color: #4EC604;
}
.content-box.medium{
  border-color: #ED9C03;
}
.content-box.hard{
  border-color: #FF0000;
}

.content-box.isRed{
  border-color: #FF0000;
}
.overlay{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  z-index: 1000000;
}
.marginer{
  margin: 20px;
}


.close-btn{
  color: black;
  border-width: 3px;
  border-color: red;
  -webkit-box-shadow: 0px 0px 10px red;
  box-shadow: 0px 0px 10px red;
  background-color: rgba(255,255,255,0.5);
  margin: 10px;
  margin-left: 0px;
  border-radius: 30px;
  padding: 20px;
  font-size: 20px;
  color: red;
}

</style>
<style lang="css">
.ddel-button{
  display: inline-block;
	/* box-shadow:inset 0px 1px 0px 0px #ffffff; */
	background-color:transparent;
	border-radius:5px;
	display:inline-block;
	cursor:pointer;
	font-family:Arial;
	font-size:20px;
	font-weight:bold;
	padding:15px 24px;
	text-decoration:none;
	text-shadow:0px 1px 0px #ffffff;
}
.ddel-button{
  color: black;
  border-width: 3px;
  border-color: #39B54A;
  box-shadow: 0px 0px 10px #39B54A;
  background-color: rgba(255,255,255,0.5);
  margin: 10px;
  margin-left: 0px;
}
</style>